import React, { Ref } from 'react'

import classNames from 'classnames'

import { ReviewAddMediaIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import useCheckinAccess from '@web/hooks/useCheckinAccess/useCheckinAccess'
import useGoToClip from '@web/hooks/useGoToClip'

import styles from './ClipCard.module.scss'

interface Props {
  clickCode: string
}

const NewClipCard = ({ clickCode }: Props, ref: Ref<HTMLLIElement>) => {
  const { goToClipCheckIn } = useGoToClip()
  const { validateAccess } = useCheckinAccess({ onSuccess: goToClipCheckIn })

  return (
    <li className={classNames(styles.list_item, styles.type_add)} ref={ref}>
      <div className={styles.list_item_inner}>
        <Clickable className={styles.list_item_link} onClick={validateAccess} nClickCode={clickCode}>
          <span className={styles.icon_area}>
            <ReviewAddMediaIcon className={styles.icon} aria-hidden="true" />
          </span>
          새 클립
          <br />
          만들기
        </Clickable>
      </div>
    </li>
  )
}
export default React.forwardRef(NewClipCard)
